<h4 class="f-w-700 f-s-24 m-t-24 m-b-8">{{"login.forgot_password" | translate}}</h4>
<span class="f-s-14 d-block f-s-14 m-t-8">
  {{"recovery_password.enter_email_account" | translate}}

</span>
<form class="m-t-30" [formGroup]="password_reset_form" (ngSubmit)="onSubmit()" #password_reset_form_dir="ngForm">
  <mat-label class="f-s-14 f-w-600 m-b-12 d-block">
    {{"recovery_password.email_address" | translate}}
  </mat-label>
  <mat-form-field appearance="outline" class="w-100" color="primary">
    <input matInput type="email" formControlName="email"/>
    <mat-error *ngIf="emailFormControl?.hasError('required') && (emailFormControl?.touched || password_reset_form_dir.submitted)">
      {{ 'login.email_required' | translate }}
    </mat-error>
  </mat-form-field>

  <button mat-flat-button color="primary" class="w-100" [disabled]="!password_reset_form.valid">
    {{"recovery_password.recovery_password" | translate}}
  </button>
  <a [routerLink]="['/login']" mat-stroked-button color="primary" class="w-100 m-t-8">
    {{"recovery_password.back_login" | translate}}
  </a>
</form>
